// @flow
import React from 'react';
import { STREAM_GOVERNANCE_RESOURCES_GRID_FIELDNAMES } from '@streaming-projects/orgs/enums';
import { SG_PACKAGE_NAME_OPTIONS } from '@src/constants';
import { SelectField } from '@src/formik-utils/FormFields';
import { STREAM_GOVERNANCE_RESOURCE_INPUTS_DETAILS_CONFIG_MAP } from '@streaming-projects/resource-definitions/stream-governance-resource-definitions/stream-governance-resource-inputs-config';

// todo::SP - get SG_PACKAGE_NAME_OPTIONS from api

export const SGResourcePackageNameContainer = ({
  disabled,
  disableOnFormErrors = null,
  fluid = null,
}) => {
  const packageNameConfig = STREAM_GOVERNANCE_RESOURCE_INPUTS_DETAILS_CONFIG_MAP.get(
    STREAM_GOVERNANCE_RESOURCES_GRID_FIELDNAMES.PACKAGE_NAME
  );

  return (
    <SelectField
      disableOnFormErrors={disableOnFormErrors}
      disabled={disabled}
      fieldDisplayName={packageNameConfig.displayName}
      fieldName={packageNameConfig.backendFieldName}
      fluid={fluid}
      options={SG_PACKAGE_NAME_OPTIONS}
      placeholder={packageNameConfig.displayName}
    />
  );
};
